import { render } from "./multipleMatch.vue?vue&type=template&id=4a39bece"
import script from "./multipleMatch.vue?vue&type=script&lang=js"
export * from "./multipleMatch.vue?vue&type=script&lang=js"

import "./multipleMatch.vue?vue&type=style&index=0&id=4a39bece&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__